import { API_URLS } from 'config/constants';

import httpServices from './http.service';

export const getMetric = () => httpServices.get(API_URLS.METRIC.GET_METRIC);
